module.exports = __webpack_public_path__ + "img/emotion-germany@2x.bef03d3.jpg";